import axiosIns from '../../../xaxios';
import { obtenerUrlAPIComisiones } from '../utils/funciones';

export default {
  async findAll(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIComisiones('documentos-personas'), opciones);
  },
  async findOne(id) {
    return await axiosIns.get(obtenerUrlAPIComisiones(`documentos-personas/${id}`));
  },
  async findByPersona(personaId, opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIComisiones(`documentos-personas/personas/${personaId}`), opciones);
  },
  async revisar(id, datos) {
    return await axiosIns.post(obtenerUrlAPIComisiones(`documentos-personas/${id}/revisar`), datos);
  },
};
